<template>
  <div>
    <form @submit.prevent="submit()">

      <div class="mb-3">
        <SGPFormInputComponent type="text" :name="'nome'" v-model="formulario.nome" :placeholder="'Nome'"
          data-vv-as="Nome" v-validate="'required|min:4'" :error="validationErrors.first('nome')" />
      </div>
      <div class="mb-3">
        <SGPFormInputComponent name="descricao" type="textarea" rows="3" placeholder="Descrição" data-vv-as="Descrição"
          :error="validationErrors.first('descricao')" v-model="formulario.descricao" />
      </div>

      <div class="container-botoes">

        <button class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize"
          type="submit">
          {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
        </button>

        <button class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize"
          type="button" @click="fecharModal()">Cancelar</button>
      </div>

    </form>


  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "FormularioEquipeComponent",

  props: {
    tipoFormulario: {
      type: String,
      required: false,
      default: 'salvar'
    },
    equipe: {
      type: Object,
      required: false
    }
  },

  data() {
    return {
      formulario: this.$props.equipe || {
        nome: '',
        descricao: '',
      }
    }
  },

  computed: {
    ...mapGetters('appCtrlEquipes', ['listaDeEquipes'])
  },
  methods: {
    ...mapActions('appCtrlEquipes', [
      'salvarEquipe',
      'atualizarEquipe',
    ]),
    submit() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          if (this.tipoFormulario === 'salvar') {

            const resp = await this.salvarEquipe(this.formulario);

            if (!resp) {
              return;
            }

            this.fecharModal();

            return;
          }

          const resp = await this.atualizarEquipe(this.formulario);

          if (!resp) {
            return;
          }

          this.fecharModal();
        }
      });
    },

    fecharModal() {
      this.$parent.$parent.$parent.$parent.fecharModal()
    }
  },


}
</script>